var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Content',{staticClass:"account-status",attrs:{"title":_vm.$t('ACCOUNT.STATUS.TITLE')}},[_c('AccountExtension'),_vm._v(" "),_c('hr',{staticClass:"divider"}),_vm._v(" "),_c('AccountReceipts')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }